export default {"src":"/_next/static/media/base-full.456e4754.svg","height":32,"width":121,"blurWidth":0,"blurHeight":0};